import { brandingImporter, environmentMapper, environments } from '@sbx/prec-shared-utils';
import axios from 'axios';

export const s3URL = process.env.VUE_APP_S3_URL;
const searchURL = process.env.VUE_APP_SEARCH_URL;
const preprodURL = process.env.VUE_APP_PREPROD_URL;
const devintURL = process.env.VUE_APP_DEVINT_URL;

const urlEnvMap = {
  [environments.production]: searchURL,
  [environments.preproduction]: preprodURL,
  [environments.devint]: devintURL,
  [environments.local]: searchURL,
};

export const getSearchURL = () => urlEnvMap[environmentMapper()] || searchURL;

export const api = {
  async get(url, additionalHeaders) {
    const { searchURLHeaders } = brandingImporter();

    const apiHeaders = { ...searchURLHeaders, ...additionalHeaders };

    const response = await axios.get(url, {
      headers: apiHeaders,
    });

    return response.data;
  },
};
